module.exports = __webpack_public_path__ + "static/media/atlas.9be15ecb.svg";